import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "search-view-desktop"
}
const _hoisted_2 = { class: "search-view-desktop__content" }

import { onBeforeUnmount, onMounted, ref } from 'vue';

import useContext from '@/composables/useContext';
import { getSearchContext } from '@/composables/useSearch';

import SearchViewDesktopResults from './SearchViewDesktopResults.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'SearchViewDesktop',
  setup(__props) {

_useCssVars(_ctx => ({
  "63d9133f": (searchResultElementPosition.value)
}))

const { mitt } = useContext();
const { searchResult } = getSearchContext();

const headerHeightScrolled = 48;
const headerHeight = 106;

const searchViewDesktop = ref<HTMLDivElement | null>(null);
const searchResultElementPosition = ref(`${headerHeight}px`);

onMounted(() => {
  searchResultsElPosition();
  window.addEventListener('click', closeIfClickIsOutsideOfSearchOverlay);
  window.addEventListener('scroll', searchResultsElPosition);
});

onBeforeUnmount(() => {
  window.removeEventListener('click', closeIfClickIsOutsideOfSearchOverlay);
  window.removeEventListener('scroll', searchResultsElPosition);
});

function searchResultsElPosition() {
  const headerEl = document.querySelector('.desktop-header');
  const topValue = headerEl?.classList?.contains('desktop-header--scrolled')
    ? headerHeightScrolled
    : headerHeight;
  searchResultElementPosition.value = `${window.scrollY + topValue}px`;
}

function closeIfClickIsOutsideOfSearchOverlay(e: any) {
  const search = document.querySelector('.desktop-header__search-bar');

  if (
    searchViewDesktop.value?.contains(e.target) ||
    (search && search.contains(e.target))
  )
    return;
  mitt.emit('close-search');
  mitt.emit('clear-search-input');
}

return (_ctx: any,_cache: any) => {
  return (_unref(searchResult))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "search-view-desktop__content-wrapper",
          ref_key: "searchViewDesktop",
          ref: searchViewDesktop
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(SearchViewDesktopResults, { "search-result": _unref(searchResult) }, null, 8, ["search-result"])
          ])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}
}

})